import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import Menu from "../../Components/Menu";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";

const PayInfo = () => {
    const navigate = useNavigate();
    let token;
    let user;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
    }
    useEffect(() => {
        document.title = "ویزیت | جزئیات پرداخت";
        token == null && navigate("/login", { replace: true });
    }, []);
    const { payId } = useParams();
    const [payInfo, setPayInfo] = useState([]);
    const [details, setDetails] = useState([]);
    const payInfoHandler = () => {
        let config = {
            url: `${baseUrl}/payment/${payId}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res.data && res.data.data && setPayInfo(res.data.data);
                res.data.data &&
                    res.data.data.details &&
                    setDetails(res.data.data.details);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        payInfoHandler();
    }, []);

    // Filter
    return (
        <div className="container">
            <div className="new-fac-main pay-factor">
                <div className="pay-fac-head">
                    <div></div>
                    <span className="title">رسید پرداخت</span>
                    <div></div>
                </div>
                <h1>{payInfo.shop && payInfo.shop.store_name}</h1>
                <span className="time"> {payInfo.Created_at} </span>

                {payInfo &&
                    details &&
                    (payInfo.type == "CHECK" ? (
                        <>
                            <div className="description no-border">
                                <div className="des-table">
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره چک
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.check_number}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            تاریخ وصول
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.received_date}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">در وجه</div>
                                        <div className="des-span-2 text-red">
                                            {details.pay_to}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره حساب
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.account_number}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره شبا
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.shaba_number}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            نام بانک
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.bank_name}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            کد شعبه
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.branch_code}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            مبلغ فاکتور
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {payInfo.value} تومان
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : payInfo.type == "CARD" ? (
                        <>
                            <div className="description no-border">
                                <div className="des-table">
                                    <div className="des-row">
                                        <div className="des-span-1">مبلغ</div>
                                        <div className="des-span-2 text-red">
                                            {payInfo.value}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره پیگیری
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.tracking_code}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">مرجع</div>
                                        <div className="des-span-2 text-red">
                                            {details.reference}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره پایانه
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.terminal_number}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            شماره کارت
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.card_number}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="des-row">
                                        <div className="des-span-1">
                                            نام دارنده کارت
                                        </div>
                                        <div className="des-span-2 text-red">
                                            {details.card_owner}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="description no-border">
                                <div className="des-table">
                                    <div className="des-row">
                                        <div className="des-span-1">مبلغ</div>
                                        <div className="des-span-2 text-red">
                                            {payInfo.value}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}
                {payInfo.Image && (
                    <img className="fac-img" src={payInfo.Image} alt="" />
                )}
                {payInfo.description && (
                    <div className="description no-border">
                        <div className="des-table mt-20">
                            <p className="fac-p">{payInfo.description}</p>
                        </div>
                    </div>
                )}
                <button
                    onClick={(e) => {
                        navigate("/panel/show_factor/" + payInfo.Order.id);
                    }}
                    className="pay-factor-btn"
                >
                    نمایش فاکتور
                </button>
                <Menu active="cart" />
            </div>
        </div>
    );
};

export default PayInfo;
